<template>
<div style="height:100%">
  
  <div class="table__container">
    <el-form ref="form" :model="selectForm" inline class="prjList_form">
      <el-form-item label="项目编号">
        <el-input v-model="selectForm.prjCode" placeholder="项目编号查询" size="small" clearable @keyup.enter.native="fetchData(1)" >
          <i slot="prefix" class="el-input__icon el-icon-search" @click="fetchData(1)" />
        </el-input>
      </el-form-item>
      <el-form-item label="项目名称">
        <el-input v-model="selectForm.prjName" placeholder="项目名称查询" size="small" clearable >
          <i slot="prefix" class="el-input__icon el-icon-search" />
        </el-input>
      </el-form-item>
      <el-form-item label="项目负责人">
        <el-input v-model="selectForm.prjLeaderName" placeholder="项目负责人查询" size="small" clearable >
          <i slot="prefix" class="el-input__icon el-icon-search" />
        </el-input>
      </el-form-item>
      <!-- <el-form-item label="项目类型">
        <el-select v-model="selectForm.prjType" size="small" placeholder clearable filterable >
          <el-option v-for="item in categoryDic" :key="item.id" :label="item.cnName" :value="item.id" />
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="项目等级">
        <el-select v-model="selectForm.prjLevel" size="small" placeholder clearable filterable >
          <el-option v-for="item in levelDic" :key="item.id" :label="item.cnName" :value="item.id" />
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" @click="getprojectlist" >查询</el-button >
        <el-button size="small" type="primary" plain @click="resetBtn" >重置</el-button >
      </el-form-item>
    </el-form>
    <!-- <el-form style="padding: 0 25px">
      <el-button v-if="downEnable" type="danger" plain size="small" @click="downExecl" > 导出 </el-button>
    </el-form> -->
    <div class="table" style="flex-grow:1;min-height:0;">
      <el-table v-loading="tableLoading"  :data="projectlist" :row-style="rowStyle" :header-cell-style="headerStyle"  highlight-current-row  height="100%"   @row-click="clickChange">
        <template slot="empty"> 
          <p style="font-size: 16px; color: #000; margin-top: 36px"> 暂无数据 </p> 
        </template>
        <el-table-column prop="prjCode" label="项目编号" min-width="130px" show-overflow-tooltip />
        <el-table-column prop="prjName" label="项目名称" min-width="150px" show-overflow-tooltip />
        <el-table-column prop="prjLeaderName" label="项目负责人" min-width="100px" align="center" />
        <!-- <el-table-column prop="prjLevel" label="项目等级" min-width="100px" align="center" /> -->
        <!-- <el-table-column prop="prjCategory" label="项目类型" min-width="100px" align="center" /> -->
        <el-table-column prop="createDate" label="立项日期" min-width="120px" />
        <el-table-column prop="updateDate" label="最近更新时间" min-width="120px" />
      </el-table>
    </div>
  </div>
  <div class="page__footer">
    <el-pagination
          :current-page.sync="page.pageNum"
          :page-size="page.pageSize"
          background
          :page-sizes="[10, 15, 20]"
          layout="total,sizes,prev, pager, next, jumper"
          :total="page.totalCount"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
  </div>
</div>
</template>

<script>
import createProjectService from "@/CommonDP/service/createProject-service";
import projectHome from "@/xgzdService/projectHome-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
export default {
  data() {
    return {
      zanwu: require('@/CommonDP/assets/暂无数据.png'),
      loading: true,
      tableLoading: false,
      prjData: [],
      prjIndex: 0,
      categoryDic: [],
      levelDic: [],
      selectForm: {
        prjCode: "",
        prjName: "",
        prjLeaderName: "",
        prjType: "",
        prjLevel: "",
      },
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
      },
      downEnable: checkPermission('createProject:down'),
      projectlist:[]
    };
  },
  watch: {
    'page.pageNum'(val) {
      this.getprojectlist()
    },
    'page.pageSize'(val) {
      this.getprojectlist()
    }
  },
  computed: {
    setParams() {
      const { prjCode, prjName, prjLeaderName, prjType, prjLevel } = this.selectForm;
      const params = {
        prjName,
        prjCode,
        leaderName:prjLeaderName,
        prjLevel,
        prjType
      };
      return params;
    },
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
    }),
  },
  mounted() {
    this.getDicList()
    this.categoryDicList()
    this.levelDicList()
    this.getprojectlist();
  },
  methods: {
    handleSizeChange(val) {
      this.page.pageSize = val || 10
    },
    handleCurrentChange(val) {
      this.page.pageNum = val
    },
    async getprojectlist() {
      this.tableLoading = true
      const { enterpriseId, selectForm:{prjName,prjCode,prjType,prjLevel,prjLeaderName}}=this;
      const params={prjName, enterpriseId,prjCode,prjCategoryId:prjType,prjLevelId: prjLevel,prjLeaderName, pageSize: this.page.pageSize, pageNum: this.page.pageNum}
      const res = await createProjectService.getPrjData(params).catch(err => {console.error('查询项目信息失败'); return {
        data: []
      }});
      this.tableLoading = false
      this.projectlist = res.data;
      this.page.totalCount = res?.totalCount || 0
    },
    clickChange(item){
      this.$store.dispatch("updatePrj", item);
      sessionStorage.setItem("prePrj", JSON.stringify(item.prjId));
      this.$router.push({name: "projectHome"});
    },
    resetBtn() {
      this.selectForm = {};
      this.page.pageNo = 1;
      this.getPrjList()
    },
    async getDicList() {
      const res = await createProjectService.dicList("ProjectStatus")
      this.options = res.data
    },
    // 项目类别
    async categoryDicList() {
      const res = await createProjectService.dicList("PrjType");
      this.categoryDic = res.data || [];
    },
    // 项目等级
    async levelDicList() {
      const res = await createProjectService.dicList("PrjLevel");
      this.levelDic = res.data || [];
    },
    fetchData(val) {
      this.page.pageNo = val;
      this.getPrjList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageNo = 1;
      this.getPrjList()
    },
    getPrjList() {
      return this.getprojectlist()
    },
    // 导出
    downExecl() {
      const a = disablePrompt()
      if (a) {
        const { enterpriseId } = this;
        const params = { enterpriseId, pageNum: 1, pageSize: 99999,...this.setParams };
        projectHome.exportExcel(params).then(response => {
          const fileName = "项目导出Excel.xlsx";
          if ("msSaveOrOpenBlob" in navigator) {
            window.navigator.msSaveOrOpenBlob(response, fileName);
            return;
          } else {
            const link = document.createElement("a");
            const blob = response;
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.excelDisable = true;
            this.excelSelect = false;
          }
        });
      }
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.prjDetail {
  height: 500px;
  overflow: auto;
}
.people_class {
  /deep/.el-dialog__body {
    height: 600px;
  }
}
.bottom_left {
  height: 100%;
  overflow: auto;
  .tree_1 {
    font-size: 14px;
  }
}
.notClick {
  cursor: not-allowed;
}
/deep/ .el-tree-node:focus > .el-tree-node__content {
  background: #6d6d6d;
}

.table__container {
  height: calc(100% - 50px);
  width: 100%;
  display: flex;
  flex-flow: column nowrap;

}
.page__footer {
  flex-shrink: 0;
  height: 50px;
  width: 100%;
  border-top: 1px solid #f4f5fa;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 10px;
  box-sizing: border-box;
}
</style>
<style lang="stylus" scoped>
.prjList_form
  padding 10px 25px
  border-bottom 1px solid rgba(211, 217, 232, 0.77)
  margin-bottom 10px
.el-form-item
  margin-bottom 0
  /deep/.el-form-item__content
    height 40px !important
.table
  padding 10px 25px
  width 100%
  height calc(100% - 200px)
.page
  .el-pagination
    margin-top 30px
    float right
    line-height 40px
</style>